module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.isContentPage) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      List of available content\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.contentTypes.children), function(type) {
    return _c('router-link', {
      key: type.name,
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "to": type.url
      }
    }, [_c('i', {
      class: type.icon
    }), _vm._v(" " + _vm._s(type.name) + "\n        ")])
  }), 1)])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a972204","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/Index.vue
// module id = 884
// module chunks = 0